import type { InvestmentLine } from 'src/tpbp-core/models/investment-lines/InvestmentLines.types'

export const API_PORTFOLIO_MANAGEMENT_MODES = {
  SELF_MANAGED: 'free_management',
  DISCRETIONARY: 'mandate_management',
  ADVISORY: 'advisory_management',
  PILOTED: 'piloted_management',
} as const

export type ApiPortfolioManagementModes = ValueOf<
  typeof API_PORTFOLIO_MANAGEMENT_MODES
>

export type ApiManagementModeKeys = 'free' | 'dpm' | 'adviced' | 'piloted'

export const MAPPING_ELIGIBLE_MANAGEMENT_TYPE_TO_MANAGEMENT_MODES = {
  free: API_PORTFOLIO_MANAGEMENT_MODES.SELF_MANAGED,
  dpm: API_PORTFOLIO_MANAGEMENT_MODES.DISCRETIONARY,
  adviced: API_PORTFOLIO_MANAGEMENT_MODES.ADVISORY,
  piloted: API_PORTFOLIO_MANAGEMENT_MODES.PILOTED,
} as const satisfies Record<ApiManagementModeKeys, ApiPortfolioManagementModes>

export type EligibleManagementTypes = Partial<
  Record<ApiManagementModeKeys, boolean>
>

export type InvestmentLinesByManagementType = Record<
  ApiPortfolioManagementModes,
  InvestmentLine[]
>
